import { render, staticRenderFns } from "./productDetailSeckill.vue?vue&type=template&id=ba60f87c&scoped=true"
import script from "./productDetailSeckill.vue?vue&type=script&lang=js"
export * from "./productDetailSeckill.vue?vue&type=script&lang=js"
import style0 from "./productDetailSeckill.vue?vue&type=style&index=0&id=ba60f87c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba60f87c",
  null
  
)

export default component.exports